const isDev = process.env.NODE_ENV === 'development';
const LOG_LEVEL = {
  NONE: 0,
  ERROR: 1,
  WARN: 2,
  INFO: 3,
  DEBUG: 4
};

// Forcer le niveau DEBUG en développement
const CURRENT_LOG_LEVEL = isDev ? LOG_LEVEL.DEBUG : LOG_LEVEL.ERROR;

export const logger = {
  debug: (...args) => {
    if (CURRENT_LOG_LEVEL >= LOG_LEVEL.DEBUG) {
      console.debug('[DEBUG]', new Date().toISOString(), ...args);
    }
  },
  info: (...args) => {
    if (CURRENT_LOG_LEVEL >= LOG_LEVEL.INFO) {
      console.info('[INFO]', new Date().toISOString(), ...args);
    }
  },
  warn: (...args) => {
    if (CURRENT_LOG_LEVEL >= LOG_LEVEL.WARN) {
      console.warn('[WARN]', new Date().toISOString(), ...args);
    }
  },
  error: (...args) => {
    if (CURRENT_LOG_LEVEL >= LOG_LEVEL.ERROR) {
      console.error('[ERROR]', new Date().toISOString(), ...args);
    }
  }
}; 